import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { UIInput, UITextArea } from "@/components/ui";
import { RequisitesBankRequest } from "@/shared/repository/modules/requisites/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    UIInput,
    UITextArea,
  },
  props: {
    bankRequisite: {
      type: <PropType<RequisitesBankRequest>>Object,
      required: true,
    },
  },
});
